module.exports = __webpack_public_path__ + "assets/img/21_1128.996920e5.jpg";